var map = {
	"./decidim/avatar-multiuser.png": 20797,
	"./decidim/brands/google.svg": 80672,
	"./decidim/cc-badge.png": 65515,
	"./decidim/decidim-logo.svg": 35839,
	"./decidim/default-avatar.svg": 80947,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 20857,
	"./decidim/icons.svg": 41154,
	"./decidim/pattern.png": 60801,
	"./decidim/placeholder-card-g.svg": 15470,
	"./decidim/placeholder-card-l.svg": 38245,
	"./decidim/placeholder.jpg": 53940,
	"./decidim/remixicon.symbol.svg": 99574,
	"./decidim/vendor/leaflet/layers-2x.png": 16979,
	"./decidim/vendor/leaflet/layers.png": 41482,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 1679,
	"./decidim/vendor/leaflet/marker-icon.png": 82534,
	"./decidim/vendor/leaflet/marker-shadow.png": 46429,
	"./decidim/vendor/social-share-button/douban.svg": 14393,
	"./decidim/vendor/social-share-button/email.svg": 24250,
	"./decidim/vendor/social-share-button/facebook.svg": 7730,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 862,
	"./decidim/vendor/social-share-button/hacker_news.svg": 38138,
	"./decidim/vendor/social-share-button/linkedin.svg": 85032,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 19265,
	"./decidim/vendor/social-share-button/pinterest.svg": 96676,
	"./decidim/vendor/social-share-button/reddit.svg": 99742,
	"./decidim/vendor/social-share-button/telegram.svg": 16511,
	"./decidim/vendor/social-share-button/tumblr.svg": 75420,
	"./decidim/vendor/social-share-button/twitter.svg": 83151,
	"./decidim/vendor/social-share-button/vkontakte.svg": 85293,
	"./decidim/vendor/social-share-button/wechat.svg": 82128,
	"./decidim/vendor/social-share-button/whatsapp.svg": 4144,
	"./decidim/vendor/social-share-button/x.svg": 71802,
	"./decidim/vendor/social-share-button/xing.svg": 72654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1590;